// Grouped client for ObjectType operations
import { ApiConfiguration } from '../ApiConfiguration';
import { Form } from '../models/Form';
import { ObjectType } from '../models/ObjectType';
import { FilterObjectTypeRequest } from '../models/FilterObjectTypeRequest';
import { DataviewObjectTypeResponse } from '../models/DataviewObjectTypeResponse';
import { FormSerializer } from '../serializers/FormSerializer';
import { ObjectTypeSerializer } from '../serializers/ObjectTypeSerializer';
import { FilterObjectTypeRequestSerializer } from '../serializers/FilterObjectTypeRequestSerializer';
import { DataviewObjectTypeResponseSerializer } from '../serializers/DataviewObjectTypeResponseSerializer';

/**
 * HTTP client for ObjectType operations
 *
 * Client for ObjectType operations
 */
export class ObjectTypeClient {
  private readonly config: ApiConfiguration;

  constructor(config: ApiConfiguration) {
    this.config = config;
  }

  async getFormForObjectType(formName: string, objectId: string, name?: string | null, fullName?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/ObjectType({objectId})/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      .replace('{objectId}', encodeURIComponent(String(objectId)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (fullName !== undefined) {
      queryParams.append('FullName', String(fullName));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async getFormForTypeObjectType(formName: string, name?: string | null, fullName?: string | null, description?: string | null, options?: { headers?: Record<string, string> }): Promise<Form> {
    let path = '/app/api/Object/ObjectType/{formName}/DataForm'
      .replace('{formName}', encodeURIComponent(String(formName)))
      ;

    const queryParams = new URLSearchParams();
    if (name !== undefined) {
      queryParams.append('Name', String(name));
    }
    if (fullName !== undefined) {
      queryParams.append('FullName', String(fullName));
    }
    if (description !== undefined) {
      queryParams.append('Description', String(description));
    }
    const queryString = queryParams.toString();
    const url = queryString ? `${this.config.baseUrl}${path}?${queryString}` : `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'GET',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return FormSerializer.fromObject(data);
  }

  async filterObjectType(request?: FilterObjectTypeRequest | null, options?: { headers?: Record<string, string> }): Promise<ObjectType[]> {
    const path = '/app/api/Object/ObjectType/Filter';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterObjectTypeRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ObjectTypeSerializer.fromObject(item));
  }

  async recentObjectType(request?: FilterObjectTypeRequest | null, options?: { headers?: Record<string, string> }): Promise<ObjectType[]> {
    const path = '/app/api/Object/ObjectType/Recent';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterObjectTypeRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return (data as any[]).map(item => ObjectTypeSerializer.fromObject(item));
  }

  async dataViewObjectType(request?: FilterObjectTypeRequest | null, options?: { headers?: Record<string, string> }): Promise<DataviewObjectTypeResponse> {
    const path = '/app/api/Object/ObjectType/DataView';

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      body: request ? JSON.stringify(FilterObjectTypeRequestSerializer.toObject(request)) : undefined,
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return DataviewObjectTypeResponseSerializer.fromObject(data);
  }

}
